import { cn } from '@/utilities/ui'
import React from 'react'

import type { Props as MediaProps } from '../types'

import { getMediaUrl } from '@/utilities/getMediaUrl'

export const VideoMedia: React.FC<MediaProps> = (props) => {
  const { resource, videoClassName } = props

  if (resource && typeof resource === 'object') {
    const { filename } = resource

    return (
      <video autoPlay className={cn(videoClassName)} controls={false} loop muted playsInline>
        <source src={getMediaUrl(`/media/${filename}`)} />
      </video>
    )
  }

  return null
}
